import { Directive, Input } from '@angular/core';
import { Validator, NG_VALIDATORS,  FormControl, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[customMin]',
  providers: [{provide: NG_VALIDATORS, useExisting: CustomMinDirective, multi: true}]
})

export class CustomMinDirective implements Validator {

  @Input('customMin')  min: number;
  constructor() { }

  validate(c: AbstractControl): {[key: string]: any} | null {
    const retVlaue = c.value;
    if (retVlaue === 0) {
      return  { 'customMin': true };
    }
    return (retVlaue && retVlaue < this.min ) ? {'customMin': true} : null;
  }
}
